// A post as the blog and the front page list it: cover, series position, title, excerpt.
import { ArrowUpRight } from "@phosphor-icons/react";
import clsx from "clsx";
import { Link } from "react-router";

import type { PostSummary } from "../../api/types";

export function PostCard({ post, large = false }: { post: PostSummary; large?: boolean }) {
  return (
    <Link to={`/blog/${post.slug}`} className={clsx("card group flex flex-col overflow-hidden transition-transform hover:-translate-y-1", large && "sm:col-span-2 lg:col-span-2 lg:flex-row")}>
      <div className={clsx("relative overflow-hidden border-b border-line bg-paper2", large ? "aspect-[16/9] lg:aspect-auto lg:w-[58%] lg:border-b-0 lg:border-e" : "aspect-[16/9]")}>
        {post.cover ? <img src={post.cover} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" /> : null}
        {post.part ? <span className="absolute start-4 top-4 rounded-full bg-ink px-2.5 py-1 font-mono text-[11px] font-semibold text-paper">{String(post.part).padStart(2, "0")}</span> : null}
      </div>
      <div className="flex flex-1 flex-col p-5 sm:p-6">
        <p className="kicker">
          {post.reading_minutes} min read{post.tags[0] ? ` · ${post.tags[0]}` : ""}
        </p>
        <h3 className={clsx("mt-3 font-display font-bold leading-tight tracking-[-0.025em]", large ? "text-3xl sm:text-4xl" : "text-2xl")}>{post.title}</h3>
        {post.subtitle ? <p className="mt-2 font-serif text-[1.05rem] italic text-ink2">{post.subtitle}</p> : null}
        <p className="mt-3 line-clamp-3 flex-1 text-[15px] leading-relaxed text-ink2">{post.excerpt}</p>
        <span className="mt-5 inline-flex items-center gap-1 text-[14px] font-semibold group-hover:text-signal">
          Read <ArrowUpRight weight="bold" className="h-4 w-4" aria-hidden />
        </span>
      </div>
    </Link>
  );
}
